import { css } from 'styled-components';
import { getTransition } from '@optimus-web/common';
import { TransitionState } from '@optimus-web/helpers';
import { TransitionProps } from './types';

export const FadeInCSS = css<TransitionProps>`
    ${(props) =>
        props.transitionState === TransitionState.ENTERING &&
        `
        opacity: 0.01;
    `}
    ${(props) =>
        props.transitionState === TransitionState.ENTERED &&
        `
        opacity: 1;
        transition: ${getTransition('opacity', props)};
    `}
    ${(props) =>
        props.transitionState === TransitionState.EXITING &&
        `
        opacity: 0.01;
        transition: ${getTransition('opacity', props)};
    `}
`;

export const SlideInFromLeftCSS = css<TransitionProps>`
    ${(props) =>
        props.transitionState === TransitionState.ENTERING &&
        `
        transform: translate3d(100%, 0, 0);
        opacity: 0.01;
    `}

    ${(props) =>
        props.transitionState === TransitionState.EXITING &&
        `
        transform: translate3d(-100%, 0, 0);
        opacity: 0.01;
        transition: ${getTransition('transform', props)}, ${getTransition('opacity', props)};
    `}

    ${(props) =>
        props.transitionState === TransitionState.ENTERED &&
        `
        opacity: 1;
        transform: translate3d(0, 0, 0);
        transition: ${getTransition('transform', props)}, ${getTransition('opacity', props)};
    `}
`;

export const SlideInFromRightCSS = css<TransitionProps>`
    ${(props) =>
        props.transitionState === TransitionState.ENTERING &&
        `
        transform: translate3d(-100%, 0, 0);
        opacity: 0.01;
    `}

    ${(props) =>
        props.transitionState === TransitionState.EXITING &&
        `
        transform: translate3d(100%, 0, 0);
        opacity: 0.01;
        transition: ${getTransition('transform', props)}, ${getTransition('opacity', props)};
    `}

    ${(props) =>
        props.transitionState === TransitionState.ENTERED &&
        `
        opacity: 1;
        transform: translate3d(0, 0, 0);
        transition: ${getTransition('transform', props)}, ${getTransition('opacity', props)};
    `}
`;

export const FadeInDelayedCSS = css<TransitionProps>`
    ${(props) =>
        props.transitionState === TransitionState.ENTERING &&
        `
        opacity: 0.01;
        max-height: 0;
    `}
    ${(props) =>
        props.transitionState === TransitionState.ENTERED &&
        `
        opacity: 1;
        max-height: 999px;
        transition: ${getTransition('all', { ...props, animationDelay: 200 })};
    `}
    ${(props) =>
        props.transitionState === TransitionState.EXITING &&
        `
        opacity: 0.01;
        transition: ${getTransition('all', props)};
    `}
`;
